import type { BarStatement, Bars } from "./contract";

export interface PowerBar {
  power: string;
  covered: number;
  total: number;
  percent: number;
  reached: boolean;
  statements: readonly BarStatement[];
}

export function reachesThreshold(covered: number, total: number, thresholdPercent: number): boolean {
  return total > 0 && covered * 100 >= thresholdPercent * total;
}

export function displayPercent(covered: number, total: number): number {
  return total > 0 ? Math.floor((covered * 100) / total) : 0;
}

/** Preserve Genesis's chosen Power order, including after the player changes it. */
export function powerBars(bars: Bars): PowerBar[] {
  return bars.powers.map(({ power, covered, total, statements }) => ({
    power,
    covered,
    total,
    percent: displayPercent(covered, total),
    reached: reachesThreshold(covered, total, bars.thresholdPercent),
    statements: [
      ...statements.filter((statement) => !statement.answered),
      ...statements.filter((statement) => statement.answered),
    ],
  }));
}
